import Vue from 'vue'
import VueRouter from 'vue-router'

import Preload from './pages/Preload'

// Main pages
import Start from './pages/Start'
import Book1 from './pages/Book1'
import Book2 from './pages/Book2'
import Karaoke from './pages/Karaoke'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   redirect:
  //   {
  //     name: 'Home'
  //   }
  // },
  {
    path: '/start',
    name: 'Start',
    component: Start
  },
  {
    path: '/book/1',
    name: 'Book1',
    component: Book1
  },
  {
    path: '/book/2',
    name: 'Book2',
    component: Book2
  },
  {
    path: '/karaoke',
    name: 'Karaoke',
    component: Karaoke
  },
  {
    path: '/preload',
    name: 'Preload',
    component: Preload
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
